
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const useEnsureAuthenticatedUser = () => {
  const navigate = useNavigate();

  return async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) {
      navigate('/login');
      throw new Error("No authenticated user");
    }

    // Check if user exists in our users table
    const { data: existingUser, error: checkError } = await supabase
      .from('users')
      .select('user_id')
      .eq('user_id', session.user.id)
      .single();

    if (checkError || !existingUser) {
      navigate('/login');
      throw new Error("User not found in database");
    }

    return session.user.id;
  };
};
